module.exports = "/_next/static/images/89d6c7d09ed6c2b59dd3f074c02db010-recibir.svg";